<script lang="tsx">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'JtDetailDrawer',
})
</script>
<!--
 * @Descripttion: 
 * @version: 详情抽屉drawer json配置组件
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-30 17:41:41
-->
<template>
  <Drawer v-bind="$attrs" :visible="visible" destroyOnClose :title="title || $lang('详情')" @close="cancel"
    :width="width || '40%'" placement="right" :maskClosable="false">
    <Spin :spinning="detailLoading">
      <Form ref="formRef" layout="vertical">
        <div v-for="(item, index) in columns" :key="index">
          <div v-if="formatterShow(item.show) !== false" class="detail-item">
            <FormGroup :title="$lang(item.groupTitle)" v-if="item.group" />
            <Row :gutter="24" v-if="!item.slot">
              <!-- 默认为6 表示默认一行4列,可根据需求自定义传入 -->
              <Col v-bind="_.span ? { span: _.span } : { xs: 24, sm: 24, md: 12, lg: 12, xl: 8, xxl: 6 }"
                v-for="_ in item.childs" v-show="formatterShow(_.show) !== false">

                <FormItem :label="$lang(_.label)">

                  <!-- 渲染图片类型  -->
                  <div class="photo-list" v-if="_.type === 'image'">
                    <!-- 兼容prop属性嵌套 深层级 -->
                    <div v-if="Array.isArray(_.prop) && _.prop.length > 1 && formState[_.prop[0]]"
                      class="photo-list-item">
                      <!-- 接口返回字段存在 -->
                      <div v-if="formState[_.prop[0]][_.prop[1]]">
                        <!--  如果存在一个字段多张图片的情况 -->
                        <template v-if="Array.isArray(formState[_.prop[0]][_.prop[1]])">
                          <Image :key="item.url" v-for="item in formState[_.prop[0]][_.prop[1]]"
                            :src="item.url || item" />
                        </template>
                        <!-- 一个字段单张图片的情况 -->
                        <Image v-else :src="formState[_.prop[0]][_.prop[1]]" />
                      </div>
                      <!-- 接口返回字段不存在 -->
                      <div v-else>--</div>
                    </div>

                <div v-else class="photo-list-item">
                  <div v-if="formState[_.prop]">
                    <template v-if="Array.isArray(formState[_.prop])">
                      <Image v-for="item in formState[_.prop]" :src="item.url || item" />
                    </template>
                    <Image v-else :src="formState[_.prop]" />
                  </div>
                  <div v-else>--</div>
                </div>
              </div>
              <!-- 渲染文本类型 -->
              <div v-else>
                <!-- customRender自定义渲染内容 -->
                <component v-if="_.customRender" :is="customRender(_.customRender, Array.isArray(_.prop) ? _.prop[_.prop.length - 1] : _.prop)" />
                <div v-else>
                  <!-- formatter格式化内容 -->
                  <div v-if="_.formatter">{{ formatter(_, Array.isArray(_.prop) ? _.prop[_.prop.length - 1] : _.prop) }}</div>
                  <div v-else>{{ formState[_.prop] || '--' }}</div>
                </div>
              </div>
            </FormItem>
            </Col>
          </Row>
          <slot v-if="item.slot"></slot>
          <slot name="afterSlot"></slot>
        </div>
      </div>
    </Form>
    </Spin>
    <slot name="footerSlot" :formState="formState" :sticky="props.sticky"></slot>
    <template v-if="props.footer" #footer>
      <Spin :spinning="detailLoading">
        <slot name="footer" :formState="formState"></slot>
      </Spin>
    </template>

  </Drawer>

</template>
<script lang="tsx" setup name="JtDetailDrawer">
import { reactive, ref, toRefs, watch } from 'vue'
import { Spin, Drawer, Row, Col, Form, FormItem, Image } from 'ant-design-vue'
import { isSuccess } from '@/utils'
import type { IColumnGroup, IColumnProp } from './type/detailDrawer.d'
import FormGroup from './FormGroup.vue'
interface IDetailDrawerProps {
  visible: boolean
  title: string
  width?: string
  columns: Array<IColumnGroup>
  params: Record<string, any>
  ajaxUrl: (params: Record<string, any>) => Promise<any>
  responseHandle?: (res: any) => void
  sticky?: boolean
  footer?: boolean
  loading?: boolean
}
const props = defineProps<IDetailDrawerProps>()
const emit = defineEmits(['update:visible', 'update:loading'])
const { visible, title, width, columns, params, ajaxUrl } = toRefs(props) as any
const formState = reactive({})
/**
 * formatter格式化方法
 * @param record 当前列数据
 * @param value 值
 * @param cb  回调函数
 */
const formatter = (record: IColumnProp, value: string) => {
  if (typeof record.formatter === 'function') {
    return record.formatter(formState, formState[value])
  }
  return ''
}

const customRender = (cb: IColumnProp['customRender'], value: string) => {
  if (typeof cb === 'function') {
    return cb(formState, formState[value])
  }
  return null
}

const formatterShow = (val: IColumnProp['show']): boolean => {
  if (typeof val === 'function') {
    return val(formState)
  }
  return val !== false
}

/**
 * 通知关闭弹窗
 */
const cancel = () => {
  Object.keys(formState).forEach((key) => {
    delete formState[key]
  })
  emit('update:visible', false)
  emit('update:loading', false)
}
const detailLoading = ref(false)
const getDetail = async () => {
  try {
    detailLoading.value = true
    emit('update:loading', true)
    const res = await ajaxUrl.value(params.value)
    if (isSuccess(res)) {
      if (props.responseHandle) props.responseHandle(res)
      Object.assign(formState, res.data)
    }
  } finally {
    emit('update:loading', false)
    detailLoading.value = false
  }
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {
      getDetail()
    } else {
      cancel()
    }
  }
)
</script>
<style lang="less" scoped>
:global(.ant-drawer-title) {
  font-size: 20px !important;
  font-weight: 600 !important;
}

p {
  margin-bottom: 0
}

:deep(.ant-form-item-label) {
  padding-bottom: 10px;
}

.photo-list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;

  &-item {
    display: flex;
  }

  :deep(.ant-image) {
    width: 50px;
    height: 50px;
    margin-top: 10px;
    margin-inline-end: 5px;
  }

  :deep(.ant-image-img) {
    border-radius: 6px;
    margin-top: 10px
  }
}

.detail-item {
  :deep(.ant-image-img) {
    width: 100%;
    height: 100%;
    object-fit: contain;
    background-color: #f5f5f5;
  }
}
</style>
